module.exports = __webpack_public_path__ + "img/zulinguanli.ea5a65a4.png";